import React from "react";
import {
  CheckoutBaseModal,
  CheckoutBaseModalItem,
} from "./checkout.base.modal";

interface HoldOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const columns: CheckoutBaseModalItem[] = [
  {
    iconName: "my-tickets",
    title: "Book your tickets",
    content: "Hold your tickets now and pay later",
  },
  {
    iconName: "email",
    title: "Receive invoice",
    content: "We will email you an invoice with information on how to pay",
  },
  {
    iconName: "dollar",
    title: "Pay balance",
    content: "Pay the balance of your invoice before the event starts",
  },
  {
    iconName: "check",
    title: "You're done",
    content: "You receive an email with your tickets",
  },
];

export const HoldOrderModal = ({ isOpen, onClose }: HoldOrderModalProps) => {
  const intro =
    "Book your tickets today and receive in invoice for your order. Tickets will be issued once your invoice has been paid and processed.";

  return (
    <CheckoutBaseModal
      isOpen={isOpen}
      onClose={onClose}
      columns={columns}
      intro={intro}
    />
  );
};
